
  <div v-if="hasMessages">
    <template v-if="isBanner">
      <transition-group appear v-for="(messageObj, type) in fullMessages" :key="type.toString()">
        <div :class="classes(type)" class="alert alert-dismissible" role="alert" :key="type.toString()">
          <row>
            <column>
              <slot>
                <ul>
<!--                  Use v-html to support links in flash messages -->
                  <li v-for="m in messageObj.messages" v-html="m"></li>
                </ul>
              </slot>
            </column>
            <suffix>
              <button v-if="messageObj.dismissible" @click="close(type)" type="button" class="btn-icon grey-to-red close">
                <icon class="times"></icon>
                <span class="sr-only">Dismiss Alert Button</span>
              </button>
            </suffix>
          </row>
        </div>
      </transition-group>
    </template>
    <modal v-else
      :state="modalStateFor(flashModalId)"
      @toggle-modal="hideModal(flashModalId)"
      :class="flashDetails.modalMaskClass">
      <h3 v-if="flashDetails.title" class="modal-title">{{flashDetails.title}}</h3>
      <h4 v-if="flashDetails.subtitle">{{flashDetails.subtitle}}</h4>
      <p v-if="flashDetails.description">{{flashDetails.description}}</p>
      <scroll-area class="lg">
        <template v-for="(messageObj, index) in fullMessages">
          <component :is="messageTag"
                     v-for="message in messageObj.messages"
                     :key="guidForMessageKey"
                     :class="flashDetails.class"
                     v-html="message" />
        </template>
      </scroll-area>
      <div class="cta">
        <button
          v-for="button in flashDetails.buttons"
          type="button"
          @click="boundAction(button)"
          :class="button.class">{{button.text}}</button>
      </div>
    </modal>
  </div>
